// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__ezxtb","author":"Table_author__3EVla","authorImage":"Table_authorImage__8gqJp","unreadRow":"Table_unreadRow__24VFu"};